import { AppDomainConstant } from "../../../app-domain.constant";

export class AprobacionConfiguracionImpresionAPIConstant {

    static readonly BASE_CONFIGURACION_IMPRESION: string = 'api/v1/configuracion-impresion/';   
    static readonly BASE_COMPROBANTE_VENTA: string = 'api/v1/ventas/comprobante/';
    static readonly BASE_PERIFERICOS: string = '8093/api/v1/perifericos/';

    static readonly URL_GET_CONFIGURACIONES_IMPRESION: string = 
    AppDomainConstant.URI_GATEWAY + 
    this.BASE_CONFIGURACION_IMPRESION +
    'configuracion-impresion/get-list-approval-by-status';

    static readonly URL_SAVE_DETALLE_PRUEBA: string = 
    AppDomainConstant.URI_GATEWAY + 
    this.BASE_CONFIGURACION_IMPRESION +
    'detalle-prueba';

    static readonly URL_SAVE_OBSERVACION: string = 
    AppDomainConstant.URI_GATEWAY + 
    this.BASE_CONFIGURACION_IMPRESION +
    'observacion';

    static readonly URL_GET_COMPROBANTE_FISICO: string = 
    AppDomainConstant.URI_GATEWAY + 
    this.BASE_COMPROBANTE_VENTA +
    'generar-comprobante-fisico';

    static readonly URL_GET_PRINTERS: string =
    AppDomainConstant.URI_BIOMETRIC +
    this.BASE_PERIFERICOS + 
    'printers';

    static readonly URL_LOCAL_PRINT: string =
    AppDomainConstant.URI_BIOMETRIC +
    this.BASE_PERIFERICOS + 
    'print';

    static readonly URL_LOCAL_PRINTER: string =
    AppDomainConstant.URI_BIOMETRIC +
    this.BASE_PERIFERICOS + 
    'printer';


}